import Rule from '../Rule';
export default class Date_ extends Rule {
    date;
    constructor(...args) {
        if (args.length === 1) {
            const rule = args[0];
            super({
                value: rule.value,
                customAttribute: rule.customAttribute,
            });
            this.date = rule.parameters;
            return;
        }
        if (args.length === 2) {
            // @ts-ignore
            super({
                value: args[0],
            });
            this.date = args[1];
            return;
        }
        throw new Error('Undefined constructor => Rule of Dates_.');
    }
    /* Create a moment instance with the right format */
    momentFormat = date => date === 'today'
        // @ts-ignore
        ? moment()
        // @ts-ignore
        : moment(date, ['L', 'YYYY-MM-DD']);
    /* take a moment instance and convert it to a date with the right format */
    format = momentInstance => momentInstance.format(['L', 'YYYY-MM-DD']);
    message() {
        return this.date === 'today'
            ? super.message('today')
            : this.replaceMessage(super.message('custom'), 'date', this.momentFormat(this.date).format('L'));
    }
}
